import React from 'react';

const ProjectCardLoader = () => {
    return (
        <div className='group animate-pulse border rounded-lg p-3 bg-white shadow-sm relative'>
            <div className="h-48  w-full rounded bg-slate-200">

            </div>
            <div className="grid grid-cols-8 py-2 content-center">
                <div className="col-span-1 grid content-center">
                    <div className="rounded-full bg-slate-200 h-8 w-8"></div>
                </div>
                <div className="col-span-7 gap-1 grid content-center">
                    <h3 className="rounded-full text-xs bg-slate-200 text-slate-200 font-semibold font-inter">Loading...</h3>
                    <p className="rounded-full text-xs bg-slate-200 text-slate-200 font-inter">Loading...</p>
                </div>
            </div>
            <div className="h-auto py-1.5">

                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>
                <button className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-xs font-inter bg-slate-200 text-slate-200'>Loading...</button>

            </div>
            <div className="p-2">
                <p className='text-sm font-inter bg-slate-200 text-slate-200'>
                    Loading...
                </p>
            </div>
        </div>
    );
};

export default ProjectCardLoader;